import { OrganizationResponseBody } from '@erm/cluster';

/**
 * Merges two lists of organizations, ensuring that there are no duplicates based on the organization_key.
 * The existing list is preserved, and any new organizations from the incoming list that are not already present are added.
 * @param existing - The existing list of organizations.
 * @param incoming - The incoming list of organizations to merge with the existing list.
 * @returns A new list of organizations that contains all unique organizations from both lists.
 */
export function mergeOrganizationListResults(
  existing: OrganizationResponseBody[],
  incoming: OrganizationResponseBody[],
): OrganizationResponseBody[] {
  const keys = new Set(existing.map((o) => o.organization_key));
  const extra = incoming.filter((o) => !keys.has(o.organization_key));
  return [...existing, ...extra];
}

export function createPendingLookup<T>(
  ids: string[],
  pendingValue: T,
): Record<string, T> {
  return Object.fromEntries(ids.map((id) => [id, pendingValue])) as Record<
    string,
    T
  >;
}
